import React from 'react';
import { Link } from 'react-router-dom';

class Header extends React.Component {
  render() {
    return (
      <nav className="navbar navbar-light">
        <div className="container">

          <Link to="/" className="navbar-brand">
            {this.props.appName.toLowerCase()}
          </Link>

          <ul className="nav navbar-nav pull-xs-right">
            <li className="nav-item">
              <Link to="/" className="nav-link">
                Sākums
              </Link>
            </li>

            <li className="nav-item dropdown">
              <Link to="/monuments" className="nav-link dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Pieminekļi un piemiņas plāksnes
              </Link>
              <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                <Link to="/monuments-black" className="dropdown-item">
                  Melni
                </Link>
                <Link to="/monuments-brownandgray" className="dropdown-item">
                  Brūni un pelēki
                </Link>
                <Link to="/monuments-boulders" className="dropdown-item">
                  Laukakmeņi
                </Link>
                <Link to="/monuments-polished" className="dropdown-item">
                  Pulētām malām
                </Link>
              </div>
            </li>

            <li className="nav-item">
              <Link to="/borders" className="nav-link">
                Apmales
              </Link>
            </li>

            <li className="nav-item">
              <Link to="/outerborders" className="nav-link">
                Laukumi
              </Link>
            </li>

            <li className="nav-item">
              <Link to="/contacts" className="nav-link">
                Kontakti
              </Link>
            </li>
          </ul>

          <select className="selectpicker">
            <option className="flag-icon flag-icon-lv flag-icon-squared"></option>
            <option></option>
            <option></option>
          </select>

        </div>
      </nav>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js